import {inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {DexTrancheUtilityService} from '../../../components/dex/dex-tranche-utility/dex-tranche-utility.service';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {
    DexTrancheDetailsWidgetSettings,
    DexTrancheDetailsWidgetSettingsDef
} from './dex-tranche-details-widget-settings';

@Injectable()
export class DexTrancheDetailsWidgetSettingsService implements WidgetSettingsService {

    private readonly dexTrancheUtilityService = inject(DexTrancheUtilityService);

    public getDefaultSettings(): Observable<DexTrancheDetailsWidgetSettings> {
        return this.fromDefinition({
            title: null,
            symbol: this.dexTrancheUtilityService.getDefaultTrancheSymbol()
        });
    }

    public fromDefinition(settingsDef: DexTrancheDetailsWidgetSettingsDef): Observable<DexTrancheDetailsWidgetSettings> {
        return of<DexTrancheDetailsWidgetSettings>({
            title:        settingsDef.title,
            symbol:       settingsDef.symbol || this.dexTrancheUtilityService.getDefaultTrancheSymbol(),
            features:     settingsDef.features,
            parentWidget: settingsDef.parentWidget || undefined
        });
    }

    public toDefinition(settings: DexTrancheDetailsWidgetSettings): DexTrancheDetailsWidgetSettingsDef {
        return {
            title:  settings.title,
            symbol: settings.symbol
        };
    }

}
